export const OWNER_ROLE = 'OWNER';
export const DEVELOPER_ROLE = 'DEVELOPER';

export type LoginResponse = {
  payload: {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
    token_type: string;
  };
  error: boolean;
  type: string;
};

export type LoginPayload = {
  email?: string;
  password?: string;
};

export type Role = {
  role: typeof OWNER_ROLE | typeof DEVELOPER_ROLE;
  account: string;
};

export type Token = {
  exp: string;
  user_name: string;
  rolesInAccounts: Role[];
};
